var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerChildCareFacilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#0000AA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.54-502.31q-15.77 0-26.81-10.88-11.04-10.89-11.04-26.66t10.89-26.8q10.89-11.04 26.65-11.04 15.77 0 26.81 10.88 11.04 10.89 11.04 26.66t-10.89 26.8q-10.89 11.04-26.65 11.04Zm-190.77 0q-15.77 0-26.81-10.88-11.04-10.89-11.04-26.66t10.89-26.8q10.89-11.04 26.65-11.04 15.77 0 26.81 10.88 11.04 10.89 11.04 26.66t-10.89 26.8q-10.89 11.04-26.65 11.04ZM480-310.77q-48.46 0-88.88-24.15-40.43-24.16-64.97-65.08h307.7q-24.54 40.92-64.97 65.08-40.42 24.15-88.88 24.15Zm.04 150.77q-66.58 0-124.77-25.04t-101.69-68.54q-43.5-43.5-68.54-101.65Q160-413.37 160-479.96q0-66.58 25.04-124.77t68.54-101.69q43.5-43.5 101.65-68.54Q413.37-800 479.96-800q66.58 0 124.77 25.04t101.69 68.54q43.5 43.5 68.54 101.65Q800-546.63 800-480.04q0 66.58-25.04 124.77t-68.54 101.69q-43.5 43.5-101.65 68.54Q546.63-160 480.04-160Zm-.04-40q116 0 198-82t82-198q0-116-82-198t-198-82q-10.87 0-21.74.77-10.88.77-20.72 2.77-2.92 7.54-3.39 13-.46 5.46-.46 13.46 0 25.62 18.35 43.96 18.34 18.35 44.19 18.35 11.08 0 17.42-3 6.35-3 14.35-3 6.73 0 11.21 5.34t4.48 12.47q0 13.65-15.34 18.61-15.35 4.96-32.35 4.96-40.38 0-69.04-28.65-28.65-28.66-28.65-69.04v-8.17q0-3.63 1.77-9.68-86.85 25.39-143.46 98.31Q200-576.62 200-480q0 116 82 198t198 82Zm0-280Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerChildCareFacilityIcon);
export default __webpack_public_path__ + "static/media/marker-child-care-facility-icon.e325c73a9588dfb3ae7473ed759da8f2.svg";
export { ForwardRef as ReactComponent };